import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { StepsContainer, StepRow, StepIconContainer, StepTextContainer, StepText, DividerContainer, DividerLineWrapper, DividerLine, CheckIcon, } from "./DocumentRetrievalRecordsShared.styles";
import { SecondaryButton } from "./PatientConsentManagerShared.styles";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import DomainDisabledIcon from "@mui/icons-material/DomainDisabled";
import { FastenButtonContainer } from "./FastenButtonContainer";
export const DocumentRetrievalRecordsNotFound = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const { isIAS, animate, canAddLocations, isAIFlow, fastenPublicId, fastenPatientId, isDataUpdate, onAddAnotherClicked, onContinueWithoutSharing, } = props;
    let sharingRecordsText;
    if (isIAS) {
        sharingRecordsText = t("Add providers and access your records");
    }
    else if (canAddLocations) {
        if (isAIFlow) {
            sharingRecordsText = t("Add providers and connect your records");
        }
        else {
            sharingRecordsText = t("Add providers and share your records");
        }
    }
    else {
        if (isAIFlow) {
            sharingRecordsText = t("Finish without connecting records");
        }
        else {
            sharingRecordsText = t("Finish without sharing records");
        }
    }
    let continueButtonText;
    if (isIAS) {
        continueButtonText = t("Continue without accessing records");
    }
    else if (isAIFlow) {
        continueButtonText = t("Continue without connecting records");
    }
    else {
        continueButtonText = t("Continue without sharing records");
    }
    const steps = [
        {
            id: "identity-verified",
            text: t("Identity verified"),
            isCompleted: true,
            isActive: false,
        },
        {
            id: "access-confirmed",
            text: isDataUpdate ? t("No records found") : t("Access confirmed but no records found"),
            isCompleted: true,
            isActive: false,
        },
        {
            id: "sharing-records",
            text: sharingRecordsText,
            isCompleted: false,
            isActive: true,
        },
    ];
    return (_jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: t("We need your help to find your records"), supportingText: t("We couldn't automatically find your records. This can happen if your providers aren't supported or have outdated details. Please add them manually to continue."), animate: animate, buttons: _jsxs(_Fragment, { children: [_jsx(FastenButtonContainer, { publicId: fastenPublicId, patientId: fastenPatientId, isStatic: false, onAddAnotherClicked: onAddAnotherClicked, heapId: "records-not-found-add-provider-button", buttonText: t("Add providers"), useSecondaryStyle: true }), _jsx(SecondaryButton, { text: true, onClick: () => onContinueWithoutSharing(), children: continueButtonText })] }), children: (isAnimating) => (_jsx(StepsContainer, { isAnimating: isAnimating, animate: animate, children: steps.map((step, index) => (_jsxs(React.Fragment, { children: [_jsxs(StepRow, { children: [_jsx(StepIconContainer, { isActive: step.isActive, isCompleted: step.isCompleted, children: step.isCompleted ? _jsx(CheckIcon, {}) : canAddLocations ? _jsx(DomainAddIcon, {}) : _jsx(DomainDisabledIcon, {}) }), _jsx(StepTextContainer, { isCompleted: step.isCompleted, children: _jsx(StepText, { isActive: step.isActive, children: step.text }) })] }), index < steps.length - 1 && (_jsxs(DividerContainer, { children: [_jsx(DividerLineWrapper, {}), _jsx(DividerLine, {})] }))] }, step.id))) })) }));
});
addDisplayName(DocumentRetrievalRecordsNotFound, "DocumentRetrievalRecordsNotFound");
